import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {faDroplet} from "@fortawesome/free-solid-svg-icons";
import {faTemperature2} from "@fortawesome/free-solid-svg-icons/faTemperature2";
import {faCalendar} from "@fortawesome/free-solid-svg-icons/faCalendar";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store";
import {DataService} from "../../../../services/data.service";
import {GraphqlService} from "../../../../services/graphql.service";
import {NotificationService} from "../../../../services/notification.service";
import {Observable} from "rxjs";
import {Warehouse} from "../../../../store/entities/warehouse-management/warehouse/warehouse.model";
import {Device} from "../../../../store/entities/warehouse-management/device/device.model";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {GET_ALL_MSD_WAREHOUSE} from "../../../../store/entities/warehouse-management/warehouse/warehouse.graphql";
import {selectStoreItems} from "../../../../store/entities/store-item/store-item.selectors";
import {GET_ALL_SENSORS} from "../../../../store/entities/warehouse-management/device/device.graphql";
import {BaseResponse} from "../../../../common/interfaces/global-interfaces";
import {gql} from "graphql-tag";
import {responseField} from "../../../../store/base.graphql";


const GET_SENSOR_PERFORMANCE_REPORT = gql`
query GetSensorPerfomanceReport($filtering: SensorPerfomanceFilteringInputObjet) {
  getSensorPerfomanceReport(filtering: $filtering) {
    response {
      ${responseField}
    }
    data {
      reportData
    }
  }
}
`

@Component({
    selector: 'app-sensor-performance-report',
    templateUrl: './sensor-performance-report.component.html',
    styleUrl: './sensor-performance-report.component.scss'
})
export class SensorPerformanceReportComponent {

    private store: Store<AppState> = inject(Store<AppState>)
    private ds: DataService = inject(DataService);
    private apollo: GraphqlService = inject(GraphqlService);
    private notificationService: NotificationService = inject(NotificationService)

    timeframeTabs: { name: string }[] = [
        {name: 'Today'}, {name: 'Yesterday'}
    ]
    @ViewChild('reportContent', {static: false}) reportContent!: ElementRef;
    activeTimeframeTab: string;

    endDate: string;
    startDate: string;

    warehouses$: Observable<Warehouse[]>;
    filtering: {
        warehouse: string;
        sensor: string;
        dateTo: string;
        dateFrom: string;
    } = {
        warehouse: null,
        sensor: null,
        dateFrom: this.ds.formatDate(new Date) + 'T00:00:00',
        dateTo: this.ds.formatDate(new Date) + 'T23:59:59'
    }

    warehouseSensors$: Observable<Device[]>;

    reportData: string
ngOnInit() {
    this.activeTimeframeTab = 'Today';

    // Load all warehouses
    this.store.dispatch(
        StoreItemActions.getStoreItems({
            entity: StoreItemEntity.warehouse,
            query: GET_ALL_MSD_WAREHOUSE,
            filtering: {}
        })
    );

    this.warehouses$ = this.store.select(selectStoreItems(StoreItemEntity.warehouse));
    this.warehouseSensors$ = this.store.select(selectStoreItems(StoreItemEntity.warehouseSensor));

    // Subscribe and set default warehouse
    this.warehouses$.subscribe((warehouses) => {
        if (warehouses?.length) {
            this.filtering.warehouse = warehouses[0].uniqueId;

            // fetch sensors for default warehouse
            this.store.dispatch(
                StoreItemActions.getStoreItems({
                    entity: StoreItemEntity.warehouseSensor,
                    query: GET_ALL_SENSORS,
                    filtering: {
                        warehouse: this.filtering.warehouse,
                        pageNumber: 1,
                        itemsPerPage: 200,
                    }
                })
            );

            // Subscribe to sensors and set default sensor
            this.warehouseSensors$.subscribe((sensors) => {
                if (sensors?.length) {
                    this.filtering.sensor = sensors[0].uniqueId;

                    // Generate report automatically
                    this.generateReport();
                }
            });
        }
    });
}



    onFilterChange(evt: string, filterType: 'timeframe' | 'frequency' | 'warehouse' | 'dateFrom' | 'dateTo') {
        switch (filterType) {
          case 'warehouse':
    this.filtering.warehouse = evt;

    // Fetch sensors for the selected warehouse
    this.store.dispatch(
        StoreItemActions.getStoreItems({
            entity: StoreItemEntity.warehouseSensor,
            query: GET_ALL_SENSORS,
            filtering: {
                warehouse: evt,
                pageNumber: 1,
                itemsPerPage: 200,
            }
        })
    );

    // Wait for sensors to load and pick first sensor as default
    this.warehouseSensors$.subscribe((sensors) => {
        if (sensors?.length) {
            this.filtering.sensor = sensors[0].uniqueId;
            this.generateReport(); // regenerate report with new warehouse + default sensor
        }
    });
    break;

    this.filtering.warehouse = evt; // update the selected warehouse
    this.store.dispatch(
        StoreItemActions.getStoreItems({
            entity: StoreItemEntity.warehouseSensor,
            query: GET_ALL_SENSORS,
            filtering: {
                warehouse: evt,
                pageNumber: 1,
                itemsPerPage: 200,
            }
        })
    );
    this.generateReport(); // optional: regenerate report on warehouse change
    break;

            case 'timeframe':
                this.startDate = null
                this.endDate = null
                switch (evt) {
                    case 'Today':
                        this.filtering.dateFrom = this.ds.formatDate(new Date) + 'T00:00:00'
                        this.filtering.dateTo = this.ds.formatDate(new Date) + 'T23:59:59'
                        break
                    case 'Yesterday':
                        let yesterdayDate = new Date();
                        yesterdayDate.setDate(yesterdayDate.getDate() - 1)
                        this.filtering.dateFrom = this.ds.formatDate(yesterdayDate) + 'T00:00:00'
                        this.filtering.dateTo = this.ds.formatDate(yesterdayDate) + 'T23:59:59'
                        break
                }
                break;
            case "dateFrom":
                this.filtering.dateFrom = this.ds.formatDate(this.startDate) + 'T00:00:00'
                break
            case 'dateTo':
                this.filtering.dateTo = this.ds.formatDate(this.endDate) + 'T23:59:59'
                break
        }

    }

    async generateReport() {
        try {
            const response: any = await this.apollo.query({
                query: GET_SENSOR_PERFORMANCE_REPORT,
                variables: {
                    filtering: this.filtering
                }
            });

            const result: BaseResponse<{ reportData: string }> = Object.values(Object.values(response)[0])[0];

            if (result?.response?.status) {
                console.log(result?.data?.reportData)
                this.reportData = result?.data?.reportData
            } else {
                throw Error(result.response.message);
            }
        } catch (e) {
            this.notificationService.errorMessage(e.message)
        }
    }


    protected readonly faTemperature2 = faTemperature2;
    protected readonly faDroplet = faDroplet;
    protected readonly faCalendar = faCalendar;
    protected readonly Math = Math;
    protected readonly Array = Array;

}
